import { Alert, AlertTitle, useTheme } from "@mui/material";

export const RussiaWarningMsg = () => {
  const theme = useTheme();

  return (
    <Alert severity="warning">
      <AlertTitle
        color={theme.palette.secondary.main}
        sx={{ fontWeight: "bold" }}
      >
        Important Notice
      </AlertTitle>
      Please be informed that the British Council has been included in the
      register of “undesirable organisations” in Russia. This is related to a
      change in Russian legislation that impacts organisations linked to foreign
      governments that are viewed as undesirable by the Russian government. Any
      connection with the British Council could potentially entail risks for
      individuals who are Russian citizens or have other ties to Russia. This
      applies even if the individuals live outside of Russia. We encourage you
      to consider this situation carefully and assess personal risks.
    </Alert>
  );
};
